import get from 'lodash/get';
import find from 'lodash/find';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import toLower from 'lodash/toLower';
import replace from 'lodash/replace';
import Scroll from 'scroll';
import {
    InventoryStatus,
    ANALYTICS_ORDER_UID,
    CHECKOUT_URL,
    PDP_URL_CONFIG_URL_PARAMETERS_INDEX,
} from '../../common/Constants';

export function getIRISSearchTerm(productType, carePlanWarrantyMap) {
    const selectedProductType = productType && productType.trim().toLowerCase();
    const irisSearchTerm = Object.keys(carePlanWarrantyMap).find((item) =>
        carePlanWarrantyMap[item].find(
            (mapItem) => mapItem.trim().toLowerCase() === selectedProductType
        )
    );
    return irisSearchTerm || '';
}

export function updateCartUID(cartDetailsResponse) {
    const analyticsAttributes = get(cartDetailsResponse, 'data.analyticsAttributes', []);
    const orderUID = find(analyticsAttributes, { type: ANALYTICS_ORDER_UID });
    if (orderUID) {
        Cookies.save('UID', orderUID.value);
    }
}

export function navigateToCheckoutFromInterstitial() {
    window.location.href = CHECKOUT_URL;
}

export function getURLParameterBykey(name, url = window.location.href) {
    // eslint-disable-next-line no-param-reassign
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function createAnalycticsSplunkParams(digitalData) {
    const productDA = [];
    digitalData.product.map((item) => {
        const pi = item.productInfo;
        productDA.push(pi.productPPID);
        /* istanbul ignore else */
        if (pi.productLotId && pi.productLotId.length > 0) {
            productDA.push(pi.productLotId.join('plid:'));
        }
        productDA.push(`sku:${pi.productSKU}`);
        productDA.push(`csp:${pi.productCurrentSellingPrice}`);
        productDA.push(`sp:${pi.productSurchargePrice}`);
        productDA.push(`pQ:${pi.productQuantity}`);
        productDA.push(`pCA:${pi.productCouponAmount}`);
        productDA.push(`pQD:${pi.productQuantityDiscount}`);
        productDA.push(`pFee:${pi.productFee}`);
        productDA.push(`pAD:${pi.productAssociateDiscount}`);
        return item;
    });
    /* istanbul ignore else */
    if (digitalData.transaction) {
        /* istanbul ignore else */
        if (digitalData.transaction.total) {
            productDA.push(`tT:${digitalData.transaction.total.totalTax}`);
            productDA.push(`tSC:${digitalData.transaction.total.shippingCost}`);
            productDA.push(`tTx:${digitalData.transaction.total.totalTax}`);
        }
        /* istanbul ignore else */
        if (digitalData.transaction.attributes) {
            productDA.push(`tTID:${digitalData.transaction.attributes.transactionID}`);
        }
    }
    return productDA;
}

export function createLogPayload(data, payload) {
    if (!payload) {
        // eslint-disable-next-line no-param-reassign
        payload = {};
    }
    if (!payload.attributes) {
        // eslint-disable-next-line no-param-reassign
        payload.attributes = [];
    }
    payload.attributes.push({
        name: data.name,
        value: data.value,
        type: data.type,
    });
    return payload;
}

export function isSyndicateURL(url) {
    return (
        url.includes('sportsfanshop.jcpenney.com') ||
        url.includes('/dotcom/jsp/cart/viewShoppingBag.jsp')
    );
}

export function getVDataAttributes(result, attr) {
    if (attr.isVdata) {
        // eslint-disable-next-line no-param-reassign
        result += `&${attr.type}=${attr.value}`;
    }
    return result;
}

export function navigateToPDPPage(
    item,
    editCartToPDPNoAdditionalParamsFF,
    enableCartRedesign = false
) {
    const url = get(item, 'product.url', '');
    try {
        if (isSyndicateURL(url)) {
            window.location.href = url;
        } else {
            // Extract the URL parameters
            const urlSplitValues = url.split('?');
            const attributes = get(item, 'attributes', []);
            const vDataAttributes = attributes.length
                ? attributes.reduce(getVDataAttributes, '')
                : '';

            const urlParameters =
                urlSplitValues.length >= 2
                    ? urlSplitValues[PDP_URL_CONFIG_URL_PARAMETERS_INDEX]
                    : /* istanbul ignore next */
                      '';
            const skuId = item.sku && item.sku.id;
            const deliveryOption = find(item.deliveryOptions, { selected: true });
            const selectedDeliveryCode = deliveryOption && deliveryOption.code;
            const deliveryZipcode = deliveryOption && deliveryOption.zipcode;
            // Find the warranty associated with the item, if one exists
            let warrantyId = 'none';
            if (item.childItems) {
                const [careItem] = item.childItems.filter(
                    (c) =>
                        c.product &&
                        c.sku &&
                        (c.product.type === 'SERVICE' || c.product.type === 'REGULAR')
                );
                warrantyId = careItem ? careItem.sku.id || careItem.id : 'none';
            }
            let pdpUrl = '';
            // TODO: Logic for Gift Registry items need to be handled
            let pTitle = toLower(replace(item.product.name, /[^a-zA-Z ]/g, '')); // remove all special cahrs except space
            pTitle = toLower(replace(pTitle, /\s+/g, '-')); // replace spaces with '-'
            pdpUrl =
                `/p/${pTitle}/${item.product.id}?cartId=${item.id}&qty=${item.quantity}` +
                `&wty=${warrantyId}&selectedSKUId=${skuId}&deliveryOption=${selectedDeliveryCode}` +
                `&updateShoppingbag=${!enableCartRedesign}&commerceId=${item.id}${
                    deliveryZipcode ? `&zipCode=${deliveryZipcode}` : ''
                }` +
                `${vDataAttributes}`;

            pdpUrl += editCartToPDPNoAdditionalParamsFF ? '' : `&${urlParameters}`;
            // Trimming Size Param from URL
            pdpUrl = pdpUrl.replace(/(\?|&)(SIZE=.*?(&|$))/gi, '$1');
            window.location.href = pdpUrl;
        }
    } catch (ex) {
        /* istanbul ignore next */
        window.location.href = url;
    }
}

export function isExtensionRequired(subdivision) {
    return subdivision === '145' || subdivision === '724' || subdivision === '250';
}

export function isAurora() {
    const auroraCookie = Cookies.load('Aurora');
    return auroraCookie && auroraCookie.includes('microservice');
}

/**
 * Return new checkout redesign enabled or not
 * @return boolean
 */
export function isNewCheckoutExperience() {
    return true;
}

export function isOOSItem(orderItem) {
    const formattedStatus =
        orderItem && orderItem.inventory.status && orderItem.inventory.status.replace(/\s/g, '');
    const inventoryStatus = InventoryStatus[`${formattedStatus}`];
    return inventoryStatus && inventoryStatus.desc === 'Out of Stock';
}

export function isCaliforniaState(orderShippingGroupsInfo) {
    const STHShippingGroup = find(orderShippingGroupsInfo, { type: 'HOME' }) || {};
    return STHShippingGroup.address && STHShippingGroup.address.state === 'CA';
}

export function scrollToElement(element, isFixedElement) {
    if (__SERVER__) {
        return;
    }

    // eg. scrolls on a sidebar
    if (element && isFixedElement) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    const topOffset = 50;
    const { top } =
        (element && element.getBoundingClientRect && element.getBoundingClientRect()) || {};

    // scrolls to the element only when it is not visible in the current view
    if ((top && topOffset > top) || !element) {
        const elementTop =
            element && element.offsetTop > topOffset ? element.offsetTop - topOffset : 0;
        const win = typeof window !== 'undefined' ? window : {};
        const doc = typeof document !== 'undefined' ? document : { documentElement: {} };
        let scrollElem = typeof win.pageYOffset === 'undefined' ? doc.documentElement : null;
        /* istanbul ignore next */
        if (!scrollElem) {
            const startScrollTop = win.pageYOffset;
            doc.documentElement.scrollTop = startScrollTop;
            // IE > 9 & FF (standard)
            scrollElem = doc.documentElement;

            // safri does not allow set documentElement.scrollTop
            if (doc.documentElement.scrollTop !== startScrollTop) {
                doc.body.scrollTop = startScrollTop;
                scrollElem = doc.body;
            }
        }
        Scroll.top(scrollElem, elementTop, { duration: 500 });
    }
}
